<template>
  <div class="col bb-combat-buttons-stack">
    <!-- ---------------------------------------- -->
    <!-- un/lock -->
    <!-- :disabled="disableLock" -->
    <div class="row d-flex justify-content-center">
      <button
        v-if="!playerMode"
        type="button"
        class="mt-2 mb-1 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <span v-if="toggleLockArena">
          <ToolTip
            text="Unlock Campaign"
            position="right"
          >
            <img
              :src="unlockArenaImg"
              @click="unlockArena()"
              height="40"
              width="40"
              alt="unlock campaign image"
            />
          </ToolTip>
        </span>
        <span v-if="!toggleLockArena">
          <ToolTip
            text="Lock Campaign"
            position="right"
          >
            <img
              :src="lockArenaImg"
              @click="lockArena()"
              height="48"
              width="48"
              alt="lock campaign image"
            />
          </ToolTip>
        </span>
      </button>
    </div>
    <!-- ---------------------------------------- -->
    <!-- new combat -->
    <div class="row d-flex justify-content-center">
      <button
        v-if="!playerMode"
        type="button"
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <ToolTip
          text="New Combat"
          position="right"
        >
          <img
            :src="newCombatImg"
            @click="newCombat()"
            height="40"
            width="40"
            alt="new combat image"
          />
        </ToolTip>
      </button>
    </div>
    <!-- ---------------------------------------- -->
    <!-- sr rolls -->
    <div class="row d-flex justify-content-center">
      <button
        v-if="!playerMode"
        type="button"
        :disabled="
          disableRolled ||
          disableInsufficientCombatants ||
          disableFilterInactive
        "
        :class="pulseRollSRs()"
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <ToolTip
          text="Strike Ranks"
          position="right"
        >
          <img
            :src="srRollImg"
            @click="srRolls()"
            height="40"
            width="40"
            alt="sr rolls image"
          />
        </ToolTip>
      </button>
    </div>
    <!-- ---------------------------------------- -->
    <!-- start/end combat -->
    <div class="row d-flex justify-content-center">
      <button
        v-if="!playerMode"
        type="button"
        :disabled="disableStart || disableInsufficientCombatants"
        :class="pulseStartCombat()"
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <span v-if="toggleStart">
          <ToolTip
            text="Start Combat"
            position="right"
          >
            <img
              :src="startCombatImg"
              @click="startCombat()"
              height="48"
              width="48"
              alt="start combat image"
            />
          </ToolTip>
        </span>
        <span v-if="!toggleStart">
          <ToolTip
            text="End Combat"
            position="right"
          >
            <img
              :src="endCombatImg"
              @click="endCombat()"
              height="48"
              width="48"
              alt="end combat image"
            />
          </ToolTip>
        </span>
      </button>
    </div>
    <!-- ---------------------------------------- -->
    <!-- extra attacks -->
    <div class="row d-flex justify-content-center">
      <button
        v-if="!playerMode"
        type="button"
        :class="pulseExtraAttacks()"
        :disabled="
          disableInsufficientCombatants ||
          disableArenaStatus ||
          toggleStart ||
          !arena_extra_ready
        "
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <ToolTip
          text="Extra Attacks"
          position="right"
        >
          <img
            :src="extraAttackImg"
            @click="extraAttacks()"
            height="40"
            width="40"
            alt="extra attack image"
          />
        </ToolTip>
      </button>
    </div>
    <!-- ---------------------------------------- -->
    <!-- bleeders -->
    <div class="row d-flex justify-content-center">
      <button
        v-if="!playerMode"
        type="button"
        :class="pulseBleeders()"
        :disabled="
          disableInsufficientCombatants ||
          disableArenaStatus ||
          toggleStart ||
          !arena_bleeders_ready ||
          arena_extra_ready
        "
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <ToolTip
          text="Bleeders"
          position="right"
        >
          <img
            :src="bleedersImg"
            @click="bleeders()"
            height="40"
            width="40"
            alt="bleeders image"
          />
        </ToolTip>
      </button>
    </div>
    <!-- ---------------------------------------- -->
    <!-- new round -->
    <div class="row d-flex justify-content-center">
      <button
        v-if="!playerMode"
        type="button"
        :class="pulseNewRound()"
        :disabled="
          disableNextRound ||
          disableInsufficientCombatants ||
          disableArenaStatus ||
          toggleStart ||
          this.arena_bleeders_ready
        "
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <ToolTip
          text="New Round"
          position="right"
        >
          <img
            :src="newRoundImg"
            @click="newRound()"
            height="40"
            width="40"
            alt="new round image"
          />
        </ToolTip>
      </button>
    </div>
    <!-- ---------------------------------------- -->
    <!-- detailed/combat cols -->
    <div class="row d-flex justify-content-center">
      <button
        type="button"
        :disabled="
          playerMode
            ? false
            : disableNoActiveCombatants || disableCosExtraMode || toggleNumbers
        "
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <!-- where FALSE = showing detailed cols -->
        <span v-if="!toggleDesc">
          <ToolTip
            text="Combat"
            position="right"
          >
            <img
              :src="hideDescImg"
              @click="descHeadingsHandler()"
              height="48"
              width="48"
              alt="toggle description image"
            />
          </ToolTip>
        </span>
        <!-- where TRUE = showing combat cols -->
        <span v-if="toggleDesc">
          <ToolTip
            text="Details"
            position="right"
          >
            <img
              :src="showDescImg"
              @click="descHeadingsHandler()"
              height="48"
              width="48"
              alt="toggle description image"
            />
          </ToolTip>
        </span>
      </button>
    </div>
    <!-- ---------------------------------------- -->
    <!-- combatant status -->
    <div class="row d-flex justify-content-center">
      <button
        v-if="!playerMode"
        id="statusBtn"
        :disabled="disableStatusButton || disableNoActiveCombatants"
        type="button"
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <!-- filter status = active -->
        <span v-if="filterStatus">
          <ToolTip
            text="Inactives"
            position="right"
          >
            <img
              :src="inactiveStatusImg"
              @click="filterStatusHandler()"
              height="48"
              width="48"
              alt="filter active status image"
            />
          </ToolTip>
        </span>
        <!-- filter status = inactive -->
        <span v-if="!filterStatus">
          <ToolTip
            text="Actives"
            position="right"
          >
            <img
              :src="activeStatusImg"
              @click="filterStatusHandler()"
              height="48"
              width="48"
              alt="filter inactive status image"
            />
          </ToolTip>
        </span>
      </button>
    </div>
    <!-- ---------------------------------------- -->
    <!-- add combatant button -->
    <div class="row d-flex justify-content-center">
      <button
        v-if="!playerMode"
        type="button"
        :disabled="
          (disableCosExtraMode && arena_active_combatants > 0) ||
          arena_ended ||
          race_count == 0 ||
          toggleNumbers
        "
        :class="pulseAddCombatants()"
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
        @click="showCombatantPanelHandler()"
      >
        <ToolTip
          text="Add Combatants"
          position="right"
        >
          <!-- <span style="font-size: 45px">+</span> -->
          <i
            class="bi bi-plus"
            style="color: white; font-size: 5em"
          ></i>
        </ToolTip>
      </button>
    </div>
    <!-- ---------------------------------------- -->
    <!-- scroll up/down -->
    <div
      v-if="showScrollButtons"
      class="row d-flex justify-content-center"
    >
      <button
        type="button"
        :disabled="true || disableNoActiveCombatants"
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <span v-if="!toggleScrollVert">
          <ToolTip
            text="Scroll Down"
            position="right"
          >
            <img
              :src="downImg"
              @click="scrollHandler('down')"
              height="48"
              width="48"
              alt="scroll down image"
            />
          </ToolTip>
        </span>
        <span v-if="toggleScrollVert">
          <ToolTip
            text="Scroll Up"
            position="right"
          >
            <img
              :src="upImg"
              @click="scrollHandler('up')"
              height="48"
              width="48"
              alt="scroll up image"
            />
          </ToolTip>
        </span>
      </button>
    </div>
    <!-- ---------------------------------------- -->
    <!-- scroll right/left -->
    <div
      v-if="showScrollButtons"
      class="row d-flex justify-content-center"
    >
      <button
        type="button"
        :disabled="true || disableNoActiveCombatants"
        class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <span v-if="!toggleScrollHorz">
          <ToolTip
            text="Scroll Right"
            position="right"
          >
            <img
              :src="rightImg"
              @click="scrollHandler('right')"
              height="48"
              width="48"
              alt="scroll right image"
            />
          </ToolTip>
        </span>
        <span v-if="toggleScrollHorz">
          <ToolTip
            text="Scroll Left"
            position="right"
          >
            <img
              :src="leftImg"
              @click="scrollHandler('left')"
              height="48"
              width="48"
              alt="scroll left image"
            />
          </ToolTip>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import getConfig from '../helpers/getConfig'
import shouldDisableViewRoundNavigation from '../helpers/shouldDisableViewRoundNavigation'
import ToolTip from '../components/ToolTip.vue'

import rightImg from '../assets/images/bbArrowRight.png'
import leftImg from '../assets/images/bbArrowLeft.png'
import upImg from '../assets/images/bbArrowUp.png'
import downImg from '../assets/images/bbArrowDown.png'
import showDescImg from '../assets/images/bbShowDesc.png'
import hideDescImg from '../assets/images/bbHideDesc.png'
import activeStatusImg from '../assets/images/bbActive50.png'
import inactiveStatusImg from '../assets/images/bbInactive50.png'
import startCombatImg from '../assets/images/bbStartCombat.png'
import endCombatImg from '../assets/images/bbEndCombat.png'
import newRoundImg from '../assets/images/bbNewRound.png'
import bleedersImg from '../assets/images/bbBleeders.png'
import newCombatImg from '../assets/images/bbNewCombat.png'
import srRollImg from '../assets/images/bbSRRolls.png'
import extraAttackImg from '../assets/images/bbExtraAttack.png'
import lockArenaImg from '../assets/images/bbLockArena.png'
import unlockArenaImg from '../assets/images/bbUnlockArena.png'
//==========================================================
// scripts
//---------
export default {
  name: 'CombatButtonsPanel',
  components: {
    ToolTip,
  },
  //==========================================================
  // props
  //-------
  props: {
    filterStatus: {
      type: Boolean,
      required: true,
    },
    arena_active_combatants: {
      type: Number,
      required: true,
    },
    arena_inactive_combatants: {
      type: Number,
      required: true,
    },
    arena_status: {
      type: String,
      required: true,
    },
    arena_round: {
      type: Number,
      required: true,
    },
    arena_action: {
      type: Number,
      required: true,
    },
    view_round: {
      type: Number,
      required: true,
    },
    arena_rolled: {
      type: Boolean,
      required: true,
    },
    arena_extra_ready: {
      type: Boolean,
      required: true,
    },
    arena_extra_action: {
      type: Number,
      required: true,
    },
    arena_bleeders_ready: {
      type: Boolean,
      required: true,
    },
    arena_round_completed: {
      type: Boolean,
      required: true,
    },
    arena_in_progress: {
      type: Boolean,
      required: true,
    },
    outstanding_rolls: {
      type: Boolean,
      required: true,
    },
    arena_locked: {
      type: Boolean,
      required: true,
    },
    arena_ended: {
      type: Boolean,
      required: true,
    },
    race_count: {
      type: Number,
      required: true,
    },
    toggleDesc: {
      type: Boolean,
      required: true,
    },
    toggleNumbers: {
      type: Boolean,
      required: true,
    },
    playerMode: {
      type: Boolean,
      default: false,
    },
  },
  //==========================================================
  // data
  //------
  data() {
    return {
      toggleScrollVert: false,
      toggleScrollHorz: false,
      toggleSRRoll: false,
      rightImg,
      leftImg,
      upImg,
      downImg,
      showDescImg,
      hideDescImg,
      activeStatusImg,
      inactiveStatusImg,
      startCombatImg,
      endCombatImg,
      newRoundImg,
      bleedersImg,
      newCombatImg,
      srRollImg,
      extraAttackImg,
      lockArenaImg,
      unlockArenaImg,
    }
  },
  //==========================================================
  // computed
  //----------
  computed: {
    //------------------------
    // tool tip texts
    //------------------------
    toolTipLockArena() {
      if (this.toggleLockArena) {
        return 'Unlock Campaign'
      } else {
        return 'Lock Campaign'
      }
    },
    toolTipStartEndCombat() {
      if (this.toggleStart) {
        return 'Start Combat'
      } else {
        return 'End Combat'
      }
    },
    toolTipToggleCols() {
      if (this.toggleDesc) {
        return 'Expand Columns'
      } else {
        return 'Collapse Columns'
      }
    },
    showScrollButtons() {
      return false
    },
    toolTipToggleStatus() {
      if (this.filterStatus) {
        return 'Inactives'
      } else {
        return 'Actives'
      }
    },
    //------------------------
    // enable/disable buttons
    //------------------------
    toggleStart() {
      if (this.arena_status == 'Active') {
        return false
      } else if (this.arena_active_combatants < 2) {
        return false
      } else {
        return true
      }
    },
    toggleLockArena() {
      if (this.arena_locked) {
        return true
      } else {
        return false
      }
    },
    disableInsufficientCombatants() {
      if (this.arena_active_combatants < 2) {
        return true
      } else {
        return false
      }
    },
    disableArenaStatus() {
      if (this.arena_status == 'Inactive') {
        return true
      } else {
        return false
      }
    },
    disableRolled() {
      if (this.arena_rolled) {
        return true
      } else {
        return false
      }
    },
    disableStart() {
      if (!this.arena_rolled) {
        return true
      } else {
        return false
      }
    },
    disableNoActiveCombatants() {
      if (this.arena_active_combatants == 0) {
        return true // disable button
      } else {
        return false // enable button
      }
    },
    disableNextRound() {
      if (!this.arena_round_completed) {
        return true
      } else {
        return false
      }
    },
    disablePreviousViewRoundButton() {
      if (this.view_round <= 1) {
        return true
      } else {
        return false
      }
    },
    disableViewRoundNavigation() {
      return shouldDisableViewRoundNavigation({
        arena_in_progress: this.arena_in_progress,
        arena_rolled: this.arena_rolled,
        outstanding_rolls: this.outstanding_rolls,
        arena_extra_ready: this.arena_extra_ready,
        arena_extra_action: this.arena_extra_action,
      })
    },
    disableNextViewRoundButton() {
      let config = getConfig()
      if (
        this.view_round == this.arena_round + config.max_view_round_increment ||
        this.arena_active_combatants < 2
      ) {
        return true
      } else {
        return false
      }
    },
    //-----------------------
    // disable status button
    //-----------------------
    disableStatusButton() {
      if (
        (this.filterStatus && this.arena_inactive_combatants == 0) ||
        this.arena_extra_action > 0
      ) {
        return true
      } else if (!this.filterStatus && this.arena_active_combatants == 0) {
        return true
      } else {
        return false
      }
    },
    //-------------------------------
    // disable where inactive filter
    //-------------------------------
    disableFilterInactive() {
      if (!this.filterStatus) {
        return true
      } else {
        return false
      }
    },
    //---------------------------------
    // disable where extra action mode
    //---------------------------------
    disableCosExtraMode() {
      if (this.arena_extra_action == 0) {
        return false
      } else {
        return true
      }
    },
    //---------------------
    // disable lock (TEMP)
    //---------------------
    // disableLock() {
    //   return true;
    // },
  },
  //==========================================================
  // methods
  //---------
  methods: {
    //--------------------------------
    // pulse buttons (add combatants)
    //--------------------------------
    pulseAddCombatants() {
      if (
        this.arena_active_combatants < 2 &&
        !this.arena_ended &&
        this.race_count > 0
      ) {
        return 'bb-button-pulse'
      } else {
        return null
      }
    },
    //--------------------------
    // pulse buttons (roll srs)
    //--------------------------
    pulseRollSRs() {
      if (
        !this.arena_rolled &&
        this.arena_active_combatants >= 2 &&
        this.filterStatus
      ) {
        return 'bb-button-pulse'
      } else {
        return null
      }
    },
    //------------------------------
    // pulse buttons (start combat)
    //------------------------------
    pulseStartCombat() {
      if (
        this.arena_rolled &&
        this.arena_status == 'Inactive' &&
        this.arena_active_combatants >= 2 &&
        this.filterStatus
      ) {
        return 'bb-button-pulse'
      } else {
        return null
      }
    },
    //---------------------------
    // pulse buttons (new round)
    //---------------------------
    pulseNewRound() {
      const config = getConfig() || {}

      if (config.auto_start_new_round === true) {
        return null
      }

      if (
        this.arena_round_completed &&
        this.arena_status == 'Active' &&
        this.arena_active_combatants >= 2 &&
        this.filterStatus &&
        !this.arena_extra_ready &&
        !this.arena_bleeders_ready
      ) {
        return 'bb-button-pulse'
      } else {
        return null
      }
    },
    //-------------------------------
    // pulse buttons (extra attacks)
    //-------------------------------
    pulseExtraAttacks() {
      if (
        this.arena_status == 'Active' &&
        this.arena_active_combatants >= 2 &&
        this.filterStatus &&
        this.arena_extra_ready
      ) {
        return 'bb-button-pulse'
      } else {
        return null
      }
    },
    //-------------------------------
    // pulse buttons (bleeders)
    //-------------------------------
    pulseBleeders() {
      if (
        this.arena_status == 'Active' &&
        this.arena_active_combatants >= 2 &&
        this.filterStatus &&
        this.arena_bleeders_ready
      ) {
        return 'bb-button-pulse'
      } else {
        return null
      }
    },
    //----------------
    // scroll handler
    //----------------
    scrollHandler(dir) {
      if (dir == 'up' || dir == 'down') {
        this.toggleScrollVert = !this.toggleScrollVert
      } else {
        this.toggleScrollHorz = !this.toggleScrollHorz
      }
      this.emitter.emit('combat-button-scroll', dir)
    },
    //------------
    // lock arena
    //------------
    lockArena() {
      this.emitter.emit('lock-arena')
    },
    //--------------
    // unlock arena
    //--------------
    unlockArena() {
      // this.toggleLockArena = !this.toggleLockArena
      this.emitter.emit('unlock-arena')
    },
    //-----------------
    // next view round
    //-----------------
    nextViewRound() {
      // this.toggleLockArena = !this.toggleLockArena
      this.emitter.emit('next-view-round')
    },
    //---------------
    // extra attacks
    //---------------
    extraAttacks() {
      this.emitter.emit('extra-attacks')
    },
    //----------
    // bleeders
    //----------
    bleeders() {
      this.emitter.emit('round-bleeders')
    },
    //---------------------
    // previous view round
    //---------------------
    previousViewRound() {
      this.emitter.emit('previous-view-round')
    },
    //------------
    // new combat
    //------------
    newCombat() {
      this.emitter.emit('new-combat')
    },
    //----------
    // sr rolls
    //----------
    srRolls() {
      this.emitter.emit('sr-rolls')
    },
    //-----------
    // new round
    //-----------
    newRound() {
      // force combat cols
      // this.toggleDesc = false
      this.emitter.emit('new-round')
    },
    //--------------
    // start combat
    //--------------
    startCombat() {
      this.emitter.emit('start-combat')
    },
    //------------
    // end combat
    //------------
    endCombat() {
      // this.toggleStart = true;
      this.emitter.emit('end-combat')
    },
    //----------------------
    // filter status handler
    //-----------------------
    filterStatusHandler() {
      this.emitter.emit('toggle-filter-status')
    },
    //------------------------------
    // description headings handler
    //------------------------------
    descHeadingsHandler() {
      this.emitter.emit('toggle-description-headings')
    },
    //----------------------------------
    // show add combatant panel handler
    //----------------------------------
    showCombatantPanelHandler() {
      this.emitter.emit('show-combatant-panel')
    },
  },
}
</script>

<style scoped>
.bb-combat-buttons-stack {
  margin-top: 2.25rem !important;
}
</style>
